import { useQuery } from "@apollo/client"
import { ChallengesDocument } from "@artists/gql/design-challenges"

import type { ChallengeResponse } from "./challenges.types"

export const useChallenges = (): ChallengeResponse => {
	const { loading, data } = useQuery(ChallengesDocument)

	const updatedPrizes = data?.defaultPrizes
		?.filter(prize => !(prize.places.length === 1 && prize.places[0] === 0))
		?.map(prize => {
			if (prize.places.includes(50)) {
				return {
					...prize,
					places: prize.places.map(place =>
						place === 50 ? 100 : place,
					),
				}
			}
			return prize
		})

	return {
		loading,
		current: data?.current.results ?? [],
		past: data?.past.results ?? [],
		prizes: updatedPrizes || [],
		partners: data?.partners ?? { regular: [], premium: [] },
	}
}
